import { render, staticRenderFns } from "./AtalanyView.vue?vue&type=template&id=5fc7d47c&scoped=true"
import script from "./AtalanyView.vue?vue&type=script&lang=js"
export * from "./AtalanyView.vue?vue&type=script&lang=js"
import style0 from "./AtalanyView.vue?vue&type=style&index=0&id=5fc7d47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7d47c",
  null
  
)

export default component.exports